export class UsersParameters {
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    role: string;
    active?: boolean;
    inactive: boolean;
    parentNotificationId? : number; 
}